export default "__VITE_ASSET__QUeWGFcF__"